import { Routes } from "@angular/router";
import { AllDocumentsComponent } from "./all-documents/all-documents.component";
import { BuyerRfqListComponent } from "./buyer-rfq-list/buyer-rfq-list.component";
import { SupplierRfqListComponent } from "./supplier-rfq-list/supplier-rfq-list.component";
import { SupplierServiceRfqListComponent } from "./supplier-service-rfq-list/supplier-service-rfq-list.component";
import { SupplierQuoteListComponent } from './supplier-quote-list/supplier-quote-list.component';
import { BuyerQuoteListComponent } from "./buyer-quote-list/buyer-quote-list.component";
import { PurchaseOrderLineItemsComponent } from "./purchase-order/purchase-order-line-items/purchase-order-line-items.component";
import { PurchaseOrderHeaderComponent } from "./purchase-order/purchase-order-header/purchase-order-header.component";
import { PurchaseOrderPaymentTermsComponent } from "./purchase-order/purchase-order-payment-terms/purchase-order-payment-terms.component";
import { PurchaseOrderPreviewComponent } from "./purchase-order/purchase-order-preview/purchase-order-preview.component"
import {  PurchaseOrderListComponent } from "./purchase-order/purchase-order-list/purchase-order-list.component";
import { SupplierPurchaseOrderListComponent } from "./purchase-order/supplier-purchase-order-list/supplier-purchase-order-list.component";
import { PurchaseOrderDetailsComponent } from "./purchase-order/purchase-order-details/purchase-order-details.component";
import { PurchaseOrderApprovalListComponent } from "./purchase-order/purchase-order-approval-list/purchase-order-approval-list.component";
import { PurchaseOrderApprovalDetailsComponent } from "./purchase-order/purchase-order-approval-details/purchase-order-approval-details.component";
import { CreateInvoiceComponent } from "./create-invoice/create-invoice.component";
import { CreateServiceInvoiceComponent } from "./create-service-invoice/create-service-invoice.component";
import { InvoiceListComponent } from "./invoice-list/invoice-list.component";
import { ServiceInvoiceListComponent } from "./service-invoice-list/service-invoice-list.component";
import { ServiceInvoiceDetailsComponent } from "./service-invoice-details/service-invoice-details.component";
import { CreateDispatchComponent } from "./create-dispatch/create-dispatch.component";
import { CreateServiceDispatchComponent } from "./create-service-dispatch/create-service-dispatch.component";
import { ConfirmOrderReceiptComponent } from "./confirm-order-receipt/confirm-order-receipt.component";
import { TokenLoginComponent } from './purchase-order/po-token-login/po-token-login.component';
import { PoTokenPurchaseOrderDetailsComponent } from './purchase-order/po-token-login/po-details/po-details.component';
import { OrderReceiptDetailsComponent } from "./order-receipt-details/order-receipt-details.component";
import { PurchaseOrderApprovalDetailsPreviewComponent } from "./purchase-order/purchase-order-approval-details-preview/purchase-order-approval-details-preview";
import { SupportTicketSystemComponent } from "./support-ticket-system/support-ticket-system";
import { ServiceSupplierQuoteListComponent } from "./service-supplier-quote-list/service-supplier-quote-list.component";
import { BuyerServiceRfqListComponent } from "./buyer-service-rfq-list/buyer-service-rfq-list.component";
import { BuyerServiceQuoteListComponent } from "./buyer-service-quote-list/buyer-service-quote-list.component";
import { ServicePurchaseOrderLineItemsComponent } from "./service-purchase-order/service-purchase-order-line-items/service-purchase-order-line-items.component";
import { ServicePurchaseOrderHeaderComponent } from "./service-purchase-order/service-purchase-order-header/service-purchase-order-header.component";
import { ServicePurchaseOrderPaymentTermsComponent } from "./service-purchase-order/service-purchase-order-payment-terms/service-purchase-order-payment-terms.component";
import { ServicePurchaseOrderPreviewComponent } from "./service-purchase-order/service-purchase-order-preview/service-purchase-order-preview.component";
import { BuyerServicePurchaseOrderListComponent } from "./buyer-service-purchase-order-list/buyer-service-purchase-order-list.component";
import { SupplierServicePurchaseOrderListComponent } from "./supplier-service-purchase-order-list/supplier-service-purchase-order-list.component";
import { SupplierServicePurchaseOrderDetailsComponent } from "./supplier-service-purchase-order-details/supplier-service-purchase-order-details.component";

export const OperationsRoutes: Routes = [
  {
    path: "",
    children: [
      {
        path: "",
        children: [
          
          {
            path: "all-documents",
            component: AllDocumentsComponent,
            data: { title: "operations/all-documents" }
          },
          {
            path:"token-login",
            component: TokenLoginComponent,
            data:{title:"operations/token-login"}
          },
          {
            path: "po-token/po-details",
            component: PoTokenPurchaseOrderDetailsComponent,
            data: { title: "operations/po-token/po-details" }
          },
          {
            path: "buyer/all-documents",
            component: BuyerRfqListComponent,
            data: { title: "operations/buyer/all-documents" }
          },{
            path:"supplier-rfq-list",
            component: SupplierRfqListComponent,
            data: {title:"operations/supplier-rfq-list"}
          },{
            path:"supplier-service-rfq-list",
            component: SupplierServiceRfqListComponent,
            data: {title:"operations/supplier-service-rfq-list"}
          },{
            path:"buyer-rfq-list",
            component: BuyerRfqListComponent,
            data: {title:"operations/buyer-rfq-list"}
          },
          {
            path:"supplier-quote-list",
            component:SupplierQuoteListComponent,
            data:{title:"operations/supplier-quote-list"}
          },
          {
            path:"buyer-quote-list",
            component:BuyerQuoteListComponent,
            data:{title:"operations/buyer-quote-list"}
          },
          {
            path:"createOrder/line-items",
            component:PurchaseOrderLineItemsComponent,
            data:{title:"operations/createOrder/line-items"}
          },
          {
            path:"createOrder/header",
            component:PurchaseOrderHeaderComponent,
            data:{title:"operations/createOrder/header"}
          },
          {
            path:"createOrder/payment-terms",
            component:PurchaseOrderPaymentTermsComponent,
            data:{title:"operations/createOrder/payment-terms"}
          },
          {
            path:"createOrder/preview",
            component:PurchaseOrderPreviewComponent,
            data:{title:"operations/createOrder/preview"}
          },
          {
            path:"purchase-order-list",
            component:  PurchaseOrderListComponent,
            data:{title:"operations/purchase-order-list"}
          },
          {
            path:"supplier-purchase-order-list",
            component:  SupplierPurchaseOrderListComponent,
            data:{title:"operations/supplier-purchase-order-list"}
          },{
            path:"purchase-order-details",
            component:  PurchaseOrderDetailsComponent,
            data:{title:"operations/purchase-order-details"}
          },{
            path:"purchase-order-approval-list",
            component:  PurchaseOrderApprovalListComponent,
            data:{title:"operations/purchase-order-approval-list"}
          },{
            path:"createOrder/approval-details",
            component: PurchaseOrderApprovalDetailsComponent,
            data:{title:"operations/createOrder/approval-details"}
          },{
            path:"createOrder/purchase-order-details",
            component: PurchaseOrderApprovalDetailsPreviewComponent,
            data:{title:"operations/createOrder/purchase-order-details"}
          },
          {
            path:"create-invoice",
            component: CreateInvoiceComponent,
            data:{title:"operations/create-invoice"}
          },
          {
            path:"create-service-invoice",
            component: CreateServiceInvoiceComponent,
            data:{title:"operations/create-service-invoice"}
          },{
            path:"invoice-list",
            component: InvoiceListComponent,
            data:{title:"operations/invoice-list"}
          },
          {
            path:"service-invoice-list",
            component: ServiceInvoiceListComponent,
            data:{title:"operations/service-invoice-list"}
          },
          {
            path:"service-invoice-details",
            component: ServiceInvoiceDetailsComponent,
            data:{title:"operations/service-invoice-details"}
          },
          {
            path:"create-dispatch",
            component: CreateDispatchComponent,
            data:{title:"operations/create-dispatch"}
          },
          {
            path:"create-service-dispatch",
            component: CreateServiceDispatchComponent,
            data:{title:"operations/create-service-dispatch"}
          },
          {
            path:"support-ticket-system",
            component: SupportTicketSystemComponent,
            data:{title:"operations/support-ticket-system"}
          },
          {
            path:"service-supplier-quote-list",
            component: ServiceSupplierQuoteListComponent,
            data:{title:"operations/service-supplier-quote-list"}
          },
          {
            path:"buyer-service-rfq-list",
            component: BuyerServiceRfqListComponent,
            data:{title:"operations/buyer-service-rfq-list"}
          },
          {
            path:"buyer-service-quote-list",
            component: BuyerServiceQuoteListComponent,
            data:{title:"operations/buyer-service-quote-list"}
          },
          {
            path:"createServiceOrder/line-items",
            component: ServicePurchaseOrderLineItemsComponent,
            data:{title:"operations/createServiceOrder/line-items"}
          },
          {
            path:"createServiceOrder/header",
            component: ServicePurchaseOrderHeaderComponent,
            data:{title:"operations/createServiceOrder/header"}
          },
          {
            path:"createServiceOrder/payment-terms",
            component: ServicePurchaseOrderPaymentTermsComponent,
            data:{title:"operations/createServiceOrder/payment-terms"}
          },
          {
            path:"createServiceOrder/preview",
            component: ServicePurchaseOrderPreviewComponent,
            data:{title:"operations/createServiceOrder/preview"}
          },
          {
            path:"buyer-service-purchase-order-list",
            component: BuyerServicePurchaseOrderListComponent,
            data:{title:"operations/buyer-service-purchase-order-list"}
          },
          {
            path:"supplier-service-purchase-order-list",
            component: SupplierServicePurchaseOrderListComponent,
            data:{title:"operations/supplier-service-purchase-order-list"}
          },
          {
            path:"supplier-service-purchase-order-details",
            component: SupplierServicePurchaseOrderDetailsComponent,
            data:{title:"operations/supplier-service-purchase-order-details"}
          },
          {
            path:"confirm-order-receipt",
            component: ConfirmOrderReceiptComponent,
            data:{title:"operations/confirm-order-receipt"}
          },
          {
            path:"order-receipt-details",
            component: OrderReceiptDetailsComponent,
            data:{title:"operations/order-receipt-details"}
          }

        ],
        data: { title: "settings" }
      },
      // {
      //   path: '**',
      //   redirectTo: '404'
      // }
    ]
  }
];
